import React, { useState } from "react";
import { Card, Dropdown, Row, Col, ProgressBar, Button } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { FaAward } from "react-icons/fa";
import { Link } from "react-router-dom";


const data = {
  week: {
    total: 154,
    stats: {
      fulltime: 112,
      contract: 112,
      probation: 12,
      wfh: 4
    }
  },
  month: {
    total: 160,
    stats: {
      fulltime: 120,
      contract: 90,
      probation: 15,
      wfh: 10
    }
  },
  today: {
    total: 150,
    stats: {
      fulltime: 110,
      contract: 100,
      probation: 8,
      wfh: 5
    }
  }
};

export default function EmployeeStatusCard() {

  const [period, setPeriod] = useState("week");

  const current = data[period];

  return (
    <Card className="employee-status-card h-100">

      {/* Header */}

      <Card.Header className="employee-header card-header-custom">

        <h5>Employee Status</h5>

        <Dropdown>
          <Dropdown.Toggle variant="light" className="border " size="sm">
            <FiCalendar className="me-1
            mb-1"/> 
            {period === "week" ? "This Week" :
             period === "month" ? "This Month" : "Today"}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={()=>setPeriod("month")}>
              This Month
            </Dropdown.Item>
            <Dropdown.Item onClick={()=>setPeriod("week")}>
              This Week
            </Dropdown.Item>
            <Dropdown.Item onClick={()=>setPeriod("today")}>
              Today
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

      </Card.Header>

      <Card.Body>

        {/* Total */}

        <div className="emp-total">
          <p>Total Employee</p>
          <h3>{current.total}</h3>
        </div>

        {/* Progress */}

        <ProgressBar className="emp-progress">

          <ProgressBar now={40} className="bar-warning"/>
          <ProgressBar now={20} className="bar-secondary"/>
          <ProgressBar now={10} className="bar-danger"/>
          <ProgressBar now={30} className="bar-pink"/>

        </ProgressBar>

        {/* Stats */}

        <div className="emp-stats">

          <Row className="g-0">

            <Col xs={6} className="stat-box border-end border-bottom">

              <p>
                <span className="dot orange"></span>
                Fulltime (48%)
              </p>

              <h2>{current.stats.fulltime}</h2>

            </Col>

            <Col xs={6} className="stat-box border-bottom text-end">

              <p>
                Contract (20%)
                <span className="dot secondary"></span>
              </p>

              <h2>{current.stats.contract}</h2>

            </Col>

            <Col xs={6} className="stat-box border-end">

              <p>
                <span className="dot danger"></span>
                Probation (22%)
              </p>

              <h2>{current.stats.probation}</h2>

            </Col>

            <Col xs={6} className="stat-box text-end">

              <p>
                WFH (20%)
                <span className="dot pink"></span>
              </p>

              <h2>{current.stats.wfh}</h2>

            </Col>

          </Row>

        </div>

        {/* Top Performer */}

        <h6 className="performer-title">Top Performer</h6>

        <div className="performer-card">

          <div className="performer-left">

            <FaAward className="award-icon"/>

            <img
              src="/assets/img/profiles/avatar-24-1.jpg"
              alt=""
              className="avatar"
            />

            <div>

              <h6>Daniel Esbella</h6>

              <p>IOS Developer</p>

            </div>

          </div>

          <div className="performer-right">

            <p>Performance</p>

            <h6>99%</h6>

          </div>

        </div>

        {/* Button */}

        <Link to="/employee-lists">

          <Button className="view-btn  border border-1 w-100">

            View All Employees

          </Button>

        </Link>

      </Card.Body>
      <style>
        {
          `.employee-status-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.employee-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:16px;
border-bottom:1px solid #eee;
}

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.employee-header h5{
font-weight:600;
font-size:18px;
}

.emp-total{
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:15px;
}

.emp-total p{
color:#6c757d;
margin:0;
}

.emp-total h3{
font-weight:700;
}

.emp-progress{
height:14px;
margin-bottom:20px;
border-radius:6px;
overflow:hidden;
}

.bar-warning{background:#fbbf24}
.bar-secondary{background:#0f4c5c}
.bar-danger{background:#ef4444}
.bar-pink{background:#ff3f7f}

.emp-stats{
border:1px solid #e9ecef;
}

.stat-box{
padding:10px;
}

.stat-box h2{
font-size:34px;
font-weight:700;
color:#1f2d3d;
}

.dot{
width:10px;
height:10px;
border-radius:50%;
display:inline-block;
margin-right:6px;
}

.orange{background:#f26522}
.secondary{background:#0f4c5c}
.danger{background:#ef4444}
.pink{background:#ff3f7f}

.performer-title{
margin:15px 0 8px;
font-weight:600;
}

.performer-card{
display:flex;
justify-content:space-between;
align-items:center;
border:1px solid #ff7a3d;
background:#fff2eb;
padding:10px;
border-radius:6px;
margin-bottom:15px;
}

.performer-left{
display:flex;
align-items:center;
gap:10px;
}

.avatar{
width:36px;
height:36px;
border-radius:50%;
}

.award-icon{
color:#ff7a3d;
font-size:20px;
}

.performer-right h6{
color:#ff7a3d;
font-weight:700;
}

.view-btn{
background:#f8f9fa;
border:none;
color:dark;
padding:10px;
}

          `
        }
      </style>

    </Card>
  );
}